export function takeLast(array = [], numberToTake = 0) {
  if (array.length <= numberToTake) {
    return array
  }
  return array.slice(array.length - numberToTake)
}
